import type { ReactElement } from 'react';
import { MDText } from 'i18n-react';

import { checkModelIsNotOther } from 'Components/Insights/hooks/useGetMakesAndModels.helpers';
import MetaTags from 'Components/MetaTags/MetaTags';
import { useInsightsStore } from 'Stores/InsightsStore/InsightsStore';

import LocalTexts from './MetaTitle.texts.json';

const LocalT = new MDText(LocalTexts);

export const MetaTitle = (): ReactElement => {
	const { make, model } = useInsightsStore((state) => state);
	const isOtherModel = !checkModelIsNotOther(model.namePretty);
	const metaModel = isOtherModel ? '' : model.namePretty;

	return (
		<MetaTags
			// @ts-expect-error MetaTags needs to be rewritten to TS
			description={LocalT.translate(`meta.description`, { make: make.name, model: metaModel })}
			title={LocalT.translate(`meta.title`, { make: make.name, model: metaModel })}
		/>
	);
};
